import {
  REQUEST_DOWNLOAD_UNIT_REPORT,
  RESPONSE_DOWNLOAD_UNIT_REPORT,
  REQUEST_DOWNLOAD_UNIT_REPORT_FAILURE,
  CLEAR_DOWNLOAD_UNIT_REPORT
} from '../actions/downloadUnitReportActions'

import { states } from './queriesStates'

const initialState = {
  dataState: states.NOT_REQUESTED,
  errors: []
}

const downloadUnitReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DOWNLOAD_UNIT_REPORT:
      return Object.assign(
        {},
        state,
        {
          dataState: states.REQUEST
        }
      )
    case RESPONSE_DOWNLOAD_UNIT_REPORT:
      return Object.assign(
        {},
        state,
        {
          dataState: states.READY
        }
      )
    case REQUEST_DOWNLOAD_UNIT_REPORT_FAILURE:
      return Object.assign(
        {},
        state,
        {
          dataState: states.FAILURE,
          errors: action.errors
        }
      )
    case CLEAR_DOWNLOAD_UNIT_REPORT:
      return Object.assign(
        {},
        state,
        initialState
      )
    default:
      return state
  }
}

export default downloadUnitReportReducer